/* Use the store language control for translated pages and legacy routes. */
(()=>{'use strict';
const languages=[['en','English'],['de','Deutsch'],['fr','Français'],['es','Español'],['it','Italiano'],['ru','Русский']];
const prefix=/^\/(en(?:-gb|-us)?|de|fr|es|it|ru)(?=\/|$)/i;
const current=()=>document.documentElement.lang.slice(0,2).toLowerCase()||'en';
function destination(locale){
  const routed=window.TacitLocaleRoutes?.target(location.href,locale);
  if(routed)return routed;
  const u=new URL(location.href),path=u.pathname.replace(prefix,'')||'/';
  u.pathname=(locale==='en'?'':'/'+locale)+path;
  return u.pathname+u.search+u.hash;
}
const style=document.createElement('style');
style.textContent='.tacit-language-menu{position:fixed;z-index:10000;width:208px;max-width:calc(100vw - 24px);padding:8px;background:#fff;color:#202421;border:1px solid #ddd;border-radius:12px;box-shadow:0 12px 32px #0002;font:inherit}.tacit-language-menu[hidden]{display:none!important}.tacit-language-menu a{display:flex;align-items:center;justify-content:space-between;min-height:44px;padding:8px 14px;border-radius:6px;color:#202421;text-decoration:none;font-size:15px;line-height:1.4}.tacit-language-menu a:hover,.tacit-language-menu a:focus-visible{background:#f3f2ed;outline:2px solid #202421;outline-offset:-2px}.tacit-language-menu a[aria-current="true"]{font-weight:700;background:#f3f2ed}';
document.head.append(style);
const menu=document.createElement('div');
menu.id='tacit-global-language-menu';menu.className='tacit-language-menu';menu.hidden=true;
menu.setAttribute('role','menu');menu.setAttribute('aria-label','Select language');
document.body.append(menu);
let trigger=null;
function close(restore=false){
  if(!trigger)return;
  const previous=trigger;previous.setAttribute('aria-expanded','false');menu.hidden=true;trigger=null;
  if(restore)previous.focus({preventScroll:true});
}
function open(button){
  if(trigger===button){close(true);return;}
  close();trigger=button;menu.replaceChildren();
  for(const [code,name] of languages){
    const link=document.createElement('a');link.href=destination(code);link.textContent=name;
    link.lang=code;link.hreflang=code;link.setAttribute('role','menuitem');
    if(code===current()){link.setAttribute('aria-current','true');const check=document.createElement('span');check.textContent='✓';check.setAttribute('aria-hidden','true');link.append(check);}
    menu.append(link);
  }
  menu.hidden=false;button.setAttribute('aria-expanded','true');
  const rect=button.getBoundingClientRect(),height=menu.offsetHeight;
  const top=rect.bottom+8+height<=innerHeight-12?rect.bottom+8:Math.max(12,rect.top-height-8);
  menu.style.top=top+'px';menu.style.left=Math.max(12,Math.min(rect.right-menu.offsetWidth,innerWidth-menu.offsetWidth-12))+'px';
  (menu.querySelector('[aria-current]')||menu.firstElementChild).focus({preventScroll:true});
}
function bind(){
  document.querySelectorAll('button[aria-controls*="localization-form-locale"],button[aria-label="Change language"]').forEach(button=>{
    if(button.dataset.tacitLanguageMenu)return;
    const nativeId=button.getAttribute('aria-controls');
    if(nativeId&&document.getElementById(nativeId)&&nativeId!==menu.id)return;
    button.dataset.tacitLanguageMenu='true';button.setAttribute('aria-controls',menu.id);
    button.setAttribute('aria-haspopup','menu');button.setAttribute('aria-expanded','false');
    const label=button.querySelector('span');if(label)label.textContent=languages.find(([code])=>code===current())?.[1]||'English';
    button.addEventListener('click',event=>{event.preventDefault();event.stopImmediatePropagation();open(button);},true);
  });
}
menu.addEventListener('keydown',event=>{
  const items=[...menu.querySelectorAll('a')],index=items.indexOf(document.activeElement);
  if(event.key==='Escape'){event.preventDefault();close(true);return;}
  const next=event.key==='ArrowDown'?(index+1)%items.length:event.key==='ArrowUp'?(index+items.length-1)%items.length:event.key==='Home'?0:event.key==='End'?items.length-1:null;
  if(next!==null){event.preventDefault();items[next].focus();}
});
document.addEventListener('click',event=>{if(trigger&&!menu.contains(event.target)&&!trigger.contains(event.target))close();});
document.addEventListener('focusin',event=>{if(trigger&&!menu.contains(event.target)&&event.target!==trigger)close();});
window.addEventListener('resize',()=>close());
window.addEventListener('scroll',()=>close(),true);
bind();new MutationObserver(bind).observe(document.body,{childList:true,subtree:true});
})();
